import { Pipe, PipeTransform } from '@angular/core';
import {Sort} from '../../../shared/libraries/sort';
import {SavedReportComponentObject, SavedReportComponentObjects} from '../../../shared/classes/saved-report-component-object';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'tableSort'
})
export class TableSortPipe implements PipeTransform {

  constructor(
    private readonly _translateService: TranslateService
  ) {}

  transform(list: SavedReportComponentObjects, value: { column: string, order: 'asc' | 'desc' | 'none' }): unknown {
    list = [...list];

    switch (value?.order) {
      case 'asc':
        list = list.sort((a: SavedReportComponentObject, b: SavedReportComponentObject): number => Sort.alphaAsc(
          this._translateService.instant('reports.' + a.payload.attributes[value.column]),
          this._translateService.instant('reports.' + b.payload.attributes[value.column])
        ));
        break;
      case 'desc':
        list = list.sort((a: SavedReportComponentObject, b: SavedReportComponentObject): number => Sort.alphaDesc(
          this._translateService.instant('reports.' + a.payload.attributes[value.column]),
          this._translateService.instant('reports.' + b.payload.attributes[value.column])
        ));
        break;
    }

    return list.sort((a: SavedReportComponentObject, b: SavedReportComponentObject): number => Sort.numberDesc(a.payload.attributes.is_favorite, b.payload.attributes.is_favorite));
  }

}
